import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DBConfigCreateRequestDTO, DBConfigDeleteRequestDTO, DBConfigDTO, DBConfigReadAllPaginatedRequestDTO, DBConfigReadByIdRequestDTO, DBConfigUpdatePasswordRequestDTO, DBConfigUpdateRequestDTO } from './dbconfig.interface';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { environment } from 'src/environments/environment';
import { ConfirmmodalserviceService } from 'src/app/Shared/confirm-delete-modal/confirmmodalservice.service';
import { DBConfigService } from './dbconfig.service';
import { passwordMatchValidator } from 'src/app/Shared/validators/passwordMatchValidator';

@Component({
  selector: 'app-dbconfig',
  templateUrl: './dbconfig.component.html',
  styleUrls: ['./dbconfig.component.css']
})
export class DBConfigComponent {

  modalService = inject(NgbModal);
  private confirmModal = inject(ConfirmmodalserviceService);
  @ViewChild('dbConfigModalContent', { static: false }) dbConfigModalContent!: ElementRef;
  addDBConfigModal!: NgbModalRef;
  dbConfigList: DBConfigDTO[] = [];
  private dbConfigService = inject(DBConfigService)
  User = inject(UserLoginService).User();
  isLoading = false;
  showDBPassword = false;

  isEditMode = false;

   @ViewChild('resetDBPasswordModalContent', { static: false }) resetDBPasswordModalContent!: ElementRef;
    resetDBPasswordModal!:NgbModalRef
    resetDBPasswordForm = new FormGroup({
        dbConnId: new FormControl(0),
        userName: new FormControl(''),
        connName: new FormControl(''),
        newPassword: new FormControl('', [Validators.required,Validators.minLength(6)]),       
        isActive: new FormControl(0),
        actionUser: new FormControl('')
      });


  ngOnInit(): void {
    this.getDBConfigList(this.PaginatedDTO);
  }
  dbConfigForm = new FormGroup({
    dbConnId: new FormControl(0),
    cName: new FormControl('', [Validators.required]),
    sName: new FormControl('', [Validators.required]),
    uName: new FormControl('', [Validators.required]),
    uPassword: new FormControl('', [Validators.required]),
    dbName: new FormControl('', [Validators.required]),
    companyId: new FormControl(0),
    branchId: new FormControl(0),
    softwareId: new FormControl(0),
    actionUser: new FormControl(''),
    isActive: new FormControl(1)
  })

  PaginatedDTO: DBConfigReadAllPaginatedRequestDTO = {
    tenantId: this.User.companyId,
    tenantBranchId: this.User.loggedInBranchId,
    softwareId: parseInt(environment.SoftwareId),
    pageNo: 1,
    pageSize: 10,

  }

  getDBConfigList(data: DBConfigReadAllPaginatedRequestDTO) { 
    this.isLoading = true;
    this.dbConfigService.DBConfig_readAllPaginated(data).subscribe({
      next: (response) => {
        this.dbConfigList = response.items;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching whatsapp config list:', err);
        this.isLoading = false;
      }
    })
  }
  openDBConfigForm() {
    this.isEditMode = false;
    this.dbConfigForm.reset();
    this.addDBConfigModal = this.modalService.open(this.dbConfigModalContent);

    this.dbConfigForm.patchValue({
      companyId: this.User.companyId,
      branchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId),
      actionUser: this.User.userId.toString(),
    });
  }

  submitDBConfigForm() {
    this.dbConfigForm.markAllAsTouched();
        if (this.dbConfigForm.valid) {
          this.isLoading = true;
          const formData = { ...this.dbConfigForm.value };
          let data = {
            tenantId: formData.companyId as number,
            tenantBranchId: formData.branchId as number,
            softwareId: formData.softwareId as number,
            dbConnId: formData.dbConnId as number,
            connName: formData.cName ?? "",
            serverName: formData.sName ?? "",
            userName: formData.uName ?? "",
            passwrd: formData.uPassword ?? "",
            dbName: formData.dbName ?? "",
            actionUser: this.User.userId.toString(),
            isActive: 1
          };
    
          if (formData.dbConnId && formData.dbConnId !== 0) {
            this.updateDBConfig(data as DBConfigUpdateRequestDTO);
          } else {
            this.createDBConfig(data as DBConfigCreateRequestDTO);
          }
        }
  }

  handlePageSizeChange(event: { currentPage: number; pageSize: number; }) {
    const { currentPage, pageSize } = event

    this.PaginatedDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId),

      pageNo: currentPage,
      pageSize: pageSize,

    }
    this.getDBConfigList(this.PaginatedDTO)

  }

  handleActionClick(event: { actionName: string, rowData: DBConfigDTO }) {
    const formData = event.rowData

    if (event.actionName === 'Delete') {
      this.confirmModal.openDeleteModal(formData.dbName!, formData).subscribe(res => {

        if (res) {
          let data: DBConfigDeleteRequestDTO = {
            dbConnId: formData.dbConnId,
            tenantId: formData.tenantId,
            tenantBranchId: formData.tenantBranchId,
            actionUser: this.User.userId.toString()
          };

          this.deleteDBConfig(data)
        }
      })
    }
    if (event.actionName === 'Edit') {
      const data: DBConfigUpdateRequestDTO = {
        ...formData,
        actionUser: this.User.userId.toString()
      };
      this.openEditModal(data);
    }
    if (event.actionName === 'Reset Password'){
      const data:DBConfigReadByIdRequestDTO={
        dbConnId: formData.dbConnId,
        tenantId: formData.tenantId,
        tenantBranchId: formData.tenantBranchId,

      }
      this.openResetDBPasswordModal(data)
    }
  }


  openEditModal(data:DBConfigUpdateRequestDTO){
    this.isEditMode = true;
    this.dbConfigForm.patchValue({
      dbConnId: data.dbConnId,
      companyId: data.tenantId,
      branchId: data.tenantBranchId,
      softwareId: data.softwareId,
      cName: data.connName,
      sName: data.serverName,
      uName: data.userName,
      uPassword:data.passwrd,
      dbName: data.dbName,
      actionUser: this.User.userId.toString(),
      isActive: 1
    })
    this.addDBConfigModal = this.modalService.open(this.dbConfigModalContent);
  }
  

  deleteDBConfig(data:DBConfigDeleteRequestDTO){
    this.isLoading = true;
    this.dbConfigService.DBConfig_delete(data).subscribe({
      next: () => {
        this.getDBConfigList(this.PaginatedDTO);
        this.isLoading = false;
      }
    });
  }

  updateDBConfig(data:DBConfigUpdateRequestDTO){
    this.dbConfigService.DBConfig_update(data).subscribe({
      next: () => {
        this.addDBConfigModal.close();
        this.getDBConfigList(this.PaginatedDTO);
        this.isLoading = false;
      }
    });
  }

  createDBConfig(data:DBConfigCreateRequestDTO){
    this.dbConfigService.DBConfig_create(data).subscribe({
      next: () => {
        this.addDBConfigModal.close()
        this.getDBConfigList(this.PaginatedDTO);
        this.isLoading = false;
      }
    })
  }

  
  openResetDBPasswordModal(data:DBConfigReadByIdRequestDTO){
    this.resetDBPasswordForm.reset();
      this.dbConfigService.DBConfig_readById(data).subscribe((res) => {
        if (res) {
          this.resetDBPasswordForm.patchValue({
            dbConnId: res.dbConnId,
            userName: res.userName,
            connName: res.connName,
            isActive: res.isActive,
            actionUser: this.User.userId.toString(),
            newPassword: ''
          });
        }
    
        // Now open the modal AFTER data is patched
        this.resetDBPasswordModal = this.modalService.open(this.resetDBPasswordModalContent);
        
      });

    }

  resetDBPassword(){
    this.resetDBPasswordForm.markAllAsTouched();
      if (this.resetDBPasswordForm.invalid) return;
    
      if (this.resetDBPasswordForm.valid) {
        const newPassword = this.resetDBPasswordForm.value.newPassword;
    
        const updatePayload: DBConfigUpdatePasswordRequestDTO = {
          
          dbConnId: this.resetDBPasswordForm.value.dbConnId!,
          tenantId: this.User.companyId,
          tenantBranchId: this.User.loggedInBranchId,
          newPassword: newPassword!,
          actionUser: this.User.userId.toString(),
        };
    
        this.dbConfigService.DBConfig_updatePassword(updatePayload).subscribe({
          next: (res) => {
            console.log('Password update response:', res);
            this.resetDBPasswordModal.close();
            this.getDBConfigList(this.PaginatedDTO); 
          },
          error: (err) => {
            console.error('Password update failed:', err);
          }
        });
      }
  }

























}
